import { LessonTask } from '../../main/types/asset/lesson.types.ts';

const DEFAULT_TASK_DETAILS = 'No current task';
const DEFAULT_VALUE = 'None';

export const mapTaskDetails = (task?: LessonTask): string => {
  if (!task) {
    return DEFAULT_TASK_DETAILS;
  }

  return `
    Task Type: ${task.taskType}
    Letters: ${task.letters?.join(', ') ?? DEFAULT_VALUE}
    Words: ${task.words?.join(', ') ?? DEFAULT_VALUE}
    Story: ${task.story?.map((line) => line.join(' ')).join(', ') ?? DEFAULT_VALUE}
    Rhyming Sounds: ${task.rhymingSounds?.join(', ') ?? DEFAULT_VALUE}
  `;
};
